import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import ExponentAV from "./ExponentAV";
export default {
  get name() {
    return 'ExpoVideoManager';
  },

  get ScaleNone() {
    return 'none';
  },

  get ScaleToFill() {
    return 'fill';
  },

  get ScaleAspectFit() {
    return 'contain';
  },

  get ScaleAspectFill() {
    return 'cover';
  },

  setFullscreen: function setFullscreen(element, isFullScreenEnabled) {
    return _regeneratorRuntime.async(function setFullscreen$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isFullScreenEnabled) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return _regeneratorRuntime.awrap(element.requestFullscreen());

          case 3:
            _context.next = 7;
            break;

          case 5:
            _context.next = 7;
            return _regeneratorRuntime.awrap(document.exitFullscreen());

          case 7:
            return _context.abrupt("return", ExponentAV.getStatusForVideo(element));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  }
};